import { APIErrorResponse, InternalHoursBalance } from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from '@/hooks/api/useQueryList'
import { QUERY_KEYS } from '@/constants'

type InternalHoursBalanceParams = {
  year?: number
}

export const getUseInternalHoursBalanceKey = () =>
  QUERY_KEYS.INTERNAL_HOURS_BALANCE as string[]

export const useInternalHoursBalance = (
  params: InternalHoursBalanceParams = {},
  enabled = true
): UseQueryResult<InternalHoursBalance, APIErrorResponse> =>
  useQueryList({
    url: '/hours_reporting/internal-hours/balance/',
    key: [...QUERY_KEYS.INTERNAL_HOURS_BALANCE, params],
    options: { enabled },
    params,
  })
